export default __webpack_public_path__ + "static/alexey2-e5b775fd5c0d4092f6eaf72e8f305221.png";